import script from "./file-access-section.vue?vue&type=script&setup=true&lang=ts"
export * from "./file-access-section.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__